import { Component, OnInit, ViewChild } from '@angular/core';
import { FileUpload, FileUploadErrorEvent } from 'primeng/fileupload';

import { HisConfirmationService, HisNotificationService, HisUiService } from 'hisng';

import { ImportJobInfo } from '../../../model/import-job-info';

@Component({
    selector: 'res-publication-excel-import',
    templateUrl: './publication-excel-import.component.html'
})
export class PublicationExcelImportComponent implements OnInit {
    @ViewChild(FileUpload, { static: true }) fileUploadComponent: FileUpload;

    public uploadUrl: string;
    public selectedFile: File;
    public selectedFileArray: File[] = [];
    public importJobInfo: ImportJobInfo;

    constructor(private hisUiService: HisUiService,
        private hisConfirmationService: HisConfirmationService,
        private notificationService: HisNotificationService) {
    }

    ngOnInit() {
        let url = window.location.href;
        let idx = url.indexOf( '/a/' );
        this.uploadUrl = url.substring( 0, idx ) + '/api/v1/fs/res/publication/import/excelUpload';
        console.log( 'uploadUrl =', this.uploadUrl );
    }

    public onSelect(event: { originalEvent: any; files: File[] }) {
        console.log('select event:', event);
        if (event.files.length > 1) {
            this.notificationService.errorI18n('fs.res.publication.import.selectOneFileNotification');
            return;
        }
        if (event.files.length === 1) {
            this.selectedFile = event.files[0];
            this.selectedFileArray = [this.selectedFile];
        }
    }

    public doImport() {
        if (!this.selectedFile) {
            this.notificationService.errorI18n('fs.res.publication.import.noFileSelectedNotification');
            return;
        }
        // ask for confirmation
        this.hisConfirmationService.confirm({
            header: this.hisUiService.translate('fs.res.publication.import.confirmationHeader'),
            message: this.hisUiService.translate('fs.res.publication.import.confirmation', this.selectedFile.name),
            icon: 'ui-icon-help',
            key: 'publicationImport',
            accept: () => {
                // start upload; when finished the onUpload() method below us called
                this.fileUploadComponent.upload();
            }
        });
    }

    public onUpload(event: { originalEvent: any; files: File[] }) {
        console.log('file uploaded event:', event);
        // The only way to get the result from p-fileupload is via the response;
        // that's a string that we still need to convert to object
        this.importJobInfo = event.originalEvent.body;
        console.log('importFile upload: response =', this.importJobInfo);
        // Start import
        console.log('Start import job!');
        // no error so far
        console.log('The import job has been started successfully.');
        this.notificationService.infoI18n('fs.res.publication.import.started', this.selectedFile.name);
        // forget file so it is not uploaded twice
        this.selectedFile = null;
        this.selectedFileArray = [];
    }

    public onError(event: FileUploadErrorEvent) {
        console.log('upload error event:', event);
        let response = event.error;
        console.log('response =', response);
        this.notificationService.errorI18n('fs.res.publication.import.error', this.selectedFile.name, (response as any).statusText);
        // create new object to avoid that the file gets lost in p-fileupload
        this.selectedFileArray = [...this.selectedFileArray];
    }
}
